import { Pages } from "./types";

export const enum AnalyticsPageSpaces {
  Spaces = "Spaces",
}

export const pagesSpaces: Pages<AnalyticsPageSpaces> = {
  [AnalyticsPageSpaces.Spaces]: ["Spaces"],
};
